import Api from '../Api';

export const getStoreInwards = query => async dispatch => {
  const { data } = await Api.get('/store-inwards', query);
  dispatch({
    type: 'FETCH_STORE_INWARDS',
    payload: data,
  });
};

export const clearStoreInwards = () => {
  return {
    type: 'CLEAR_STORE_INWARDS',
  };
};

export const getStoreInward = id => async dispatch => {
  const { data } = await Api.get(`/store-inwards/${id}`);
  dispatch({
    type: 'FETCH_STORE_INWARD',
    payload: data,
  });
};

export const clearStoreInward = () => {
  return {
    type: 'CLEAR_STORE_INWARD',
  };
};

export const getStoreInwardsOfRpo = id => async dispatch => {
  const { data } = await Api.get(`/store-inwards/rpo/${id}`);
  dispatch({
    type: 'FETCH_STORE_INWARDS_OF_RPO',
    payload: data,
  });
};

export const clearStoreInwardsofRpo = () => {
  return {
    type: 'CLEAR_STORE_INWARDS_OF_RPO',
  };
};

export const getInwardItemsForQualityCheckTable = id => async dispatch => {
  const { data } = await Api.get(
    `/store-inwards/inwarditemsforqualitychecktable/${id}`
  );
  dispatch({
    type: 'FETCH_STORE_INWARD_FOR_QUALITY_CHECK_INPUT_TABLE',
    payload: data,
  });
};

export const clearInwardItemsForQualityCheckTable = () => {
  return {
    type: 'CLEAR_STORE_INWARD_FOR_QUALITY_CHECK_INPUT_TABLE',
  };
};

export const getMRR = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/mrr`, query);
  dispatch({
    type: 'FETCH_MRR',
    payload: data,
  });
};

export const clearMRR = () => {
  return {
    type: 'CLEAR_MRR',
  };
};

export const getCustomerIdsForMrr = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/dropdowns/customerids`, query);
  dispatch({
    type: 'FETCH_CUSTOMER_IDS_FOR_MRR',
    payload: data,
  });
};

export const clearCustomerIdsForMrr = () => {
  return {
    type: 'CLEAR_CUSTOMER_IDS_FOR_MRR',
  };
};

export const getJobchartIdsForMrr = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/dropdowns/jobchartids`, query);
  dispatch({
    type: 'FETCH_JOBCHART_IDS_FOR_MRR',
    payload: data,
  });
};

export const clearJobchartIdsForMrr = () => {
  return {
    type: 'CLEAR_JOBCHART_IDS_FOR_MRR',
  };
};

export const getProcessesForMrr = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/dropdowns/processes`, query);
  dispatch({
    type: 'FETCH_PROCESSES_FOR_MRR',
    payload: data,
  });
};

export const clearProcessesForMrr = () => {
  return {
    type: 'CLEAR_PROCESSES_FOR_MRR',
  };
};

export const getVendorIdsForMrr = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/dropdowns/vendorids`, query);
  dispatch({
    type: 'FETCH_VENDOR_IDS_FOR_MRR',
    payload: data,
  });
};

export const clearVendorIdsForMrr = () => {
  return {
    type: 'CLEAR_VENDOR_IDS_FOR_MRR',
  };
};

export const getRPOIdsForMrr = query => async dispatch => {
  const { data } = await Api.get(`/store-inwards/dropdowns/rpoids`, query);
  dispatch({
    type: 'FETCH_RPO_IDS_FOR_MRR',
    payload: data,
  });
};

export const clearRPOIdsForMrr = () => {
  return {
    type: 'CLEAR_RPO_IDS_FOR_MRR',
  };
};
